import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISubscription, SubscriptionPlan, SubscriptionStatus } from '../../../../Utils/_models/subscription.model';

@Component({
  selector: 'app-view-subscription-modal',
  standalone: true,
  imports: [CommonModule,],
  templateUrl: './view-subscription-modal.component.html',
  styleUrl: './view-subscription-modal.component.css',
})
export class ViewSubscriptionModalComponent implements OnInit {
  @Input() visible = false;
  @Input() subscription!: ISubscription;
  @Output() onClose = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  close(): void {
    this.onClose.emit();
  }

  getPlanClass(plan: SubscriptionPlan): string {
    const map: Record<SubscriptionPlan, string> = {
      'Pro Plan': 'plan-pro',
      'Basic Plan': 'plan-basic',
      'Enterprise': 'plan-enterprise',
      'Free': 'plan-free',
    };
    return map[plan] ?? '';
  }

  getStatusClass(status: SubscriptionStatus | string): string {
    const map: Record<string, string> = {
      Active: 'status-active',
      Inactive: 'status-expired',
      Cancelled: 'status-cancelled',
      Expired: 'status-expired',
      Pending: 'status-pending',
      Free: 'status-active',
    };
    return map[status] ?? '';
  }
}
